



















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { utils, writeFileXLSX } from 'xlsx';
import readXlsFile from 'read-excel-file';

import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { fetchMS } from './fetchMS';
import { ParamApi, FiltersApi, DateType } from './models/BajasCobranza.models';

@Component({ components: {} })
export default class ModalCargueArchivo extends Vue {
  readonly loadingService: LoadingService = new LoadingService();
  readonly $snotify: Snotify = null;

  @Prop({ default: true }) show: boolean;
  @Prop({ default: '' }) text!: string;
  @Prop({ required: true, default: {} }) filterApi!: FiltersApi;
  fileName: any = '';
  archivoB64: any = '';
  itemsDelExcel: Array<any> = [];
  errorArchivo: boolean = true;
  errorArchivoModal: boolean = false;
  errorMessage: any = '';

  handleCloseReport(): void {
    this.$emit('cerrar');
  }

  mounted() {}

  quitarRegistro() {
    let input = document.getElementById(
      'archivoExcel'
    ) as HTMLInputElement | null;
    if (input) {
      input.value = ''; // Restablecer el valor del input
    }
    this.itemsDelExcel = [];
    this.archivoB64 = '';
    this.fileName = '';
    this.errorArchivoModal = false;
    this.errorMessage = '';
    this.errorArchivo = true;
  }

  prepare_file_upload() {
    let self = this;
    const input = document.getElementById(
      'archivoExcel'
    ) as HTMLInputElement | null;
    if (input != null && input.files) {
      this.fileName = input.files[0].name;
      const file = input.files[0];
      const reader = new FileReader();
      let rawImg;
      reader.onloadend = () => {
        rawImg = reader.result;
        this.archivoB64 = rawImg;
      };
      reader.readAsDataURL(file);
      readXlsFile(input.files[0])
        .then((rows: any) => {
          let datos: any = [...rows];
          if (datos.length == 0) {
            console.log('1');
            self.$snotify.warning(
              'Se espera que la primera columna tenga el título "nombre baja cobranza"'
            );
            this.errorArchivo = true;
            return;
          }
          let firtsRow: any = datos[0] || '';
          console.log(firtsRow[0] == null);
          if (
            firtsRow[0] == null ||
            firtsRow[0].toLowerCase() != 'nombre baja cobranza'
          ) {
            console.log('1');
            self.$snotify.warning(
              'Se espera que la primera columna tenga el título "nombre baja cobranza"'
            );
            this.errorArchivo = true;
            return;
          }
          datos = datos.splice(1);
          if (!datos[0]) {
            console.log('1');

            self.$snotify.warning(
              'Se espera que la primera columna tenga el título "nombre baja cobranza"'
            );
            this.errorArchivo = true;
            return;
          }
          let hasError = false;

          const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
          const isValidNombre = (
            value: any,
            objects: any[],
            propName: string
          ) => {
            const found = objects.find(obj => obj[propName] === value);
            return {
              isValid: found !== undefined,
              idBajaTemporal: found ? found.id_baja_temporal : null,
            };
          };
          this.itemsDelExcel = datos.map((item: any, index: number) => {
            const tramoTemporal = item[8];
            const tramoDefinitivo = item[9];
            const tramoTemporalValido = isValidNombre(
              tramoTemporal,
              this.filterApi.TEMPORAL,
              'baja_temporal'
            );
            const tramoDefinitivoValido = isValidNombre(
              tramoDefinitivo,
              this.filterApi.TEMPORAL,
              'baja_temporal'
            );
            const bajaTemporalFecha = item[10];
            const bajaDefinitivaFecha = item[11];
            const fechaRecuperacion = item[12];
            let fechaBajaTemporal;
            let fechaBajaDefinitiva;
            let fechaRecuperacionvalida;
            if (bajaTemporalFecha === null) {
              item[10] = null;
              fechaBajaTemporal = true;
            } else if (!isNaN(bajaTemporalFecha)) {
              const fechaTemporalDate = this.excelSerialToDate(
                bajaTemporalFecha
              );
              item[10] = this.formatDate(fechaTemporalDate); // Convertir la fecha a formato yyyy-mm-dd
              fechaBajaTemporal = dateRegex.test(item[10]);
            } else {
              // Si no es un número y no es null, se maneja como un caso de error
              fechaBajaTemporal = false;
            }

            if (bajaDefinitivaFecha === null) {
              item[11] = null;
              fechaBajaDefinitiva = true; // Consideramos que un null es válido según tus requerimientos
            } else if (!isNaN(bajaDefinitivaFecha)) {
              const fechaDefinitivaDate = this.excelSerialToDate(
                bajaDefinitivaFecha
              );
              item[11] = this.formatDate(fechaDefinitivaDate); // Convertir la fecha a formato yyyy-mm-dd
              fechaBajaDefinitiva = dateRegex.test(item[11]);
            } else {
              // Si no es un número y no es null, se maneja como un caso de error
              fechaBajaDefinitiva = false;
            }

            if (fechaRecuperacion === null) {
              item[12] = null;
              fechaRecuperacionvalida = true; // Consideramos que un null es válido según tus requerimientos
            } else if (!isNaN(fechaRecuperacion)) {
              const fechaRecuperacionDate = this.excelSerialToDate(
                fechaRecuperacion
              );
              item[12] = this.formatDate(fechaRecuperacionDate); // Convertir la fecha a formato yyyy-mm-dd
              fechaRecuperacionvalida = dateRegex.test(item[12]);
            } else {
              // Si no es un número y no es null, se maneja como un caso de error
              fechaRecuperacionvalida = false;
            }

            if (!tramoTemporalValido.isValid) {
              this.errorMessage += `Fila ${index +
                2}: Tramo Temporal no válido: ${tramoTemporal}.<br>`;
              hasError = true;
            }

            if (!tramoDefinitivoValido.isValid) {
              this.errorMessage += `Fila ${index +
                2}: Tramo Definitivo no válido: ${tramoDefinitivo}.<br>`;
              hasError = true;
            }
            if (hasError) {
              return null;
            }
            return {
              NombreBajaCobranza: item[0] || '',
              CantidadEPC: item[3] || '',
              Descripcion: item[4] || '',
              Observaciones: item[5] || '',
              NombreTramoBajaTemporal: tramoTemporalValido.isValid
                ? tramoTemporalValido.idBajaTemporal
                : null,
              NombreTramoBajaDefinitiva: tramoDefinitivoValido.isValid
                ? tramoDefinitivoValido.idBajaTemporal
                : null,
              FechaIngresoBajaTemporal: item[10] || null,
              FechaIngresoBajaDefinitiva: item[11] || null,
              FechaRecuperacionCliente: item[12] || null,
            };
          });
          if (hasError) {
            this.errorArchivo = true;
            this.itemsDelExcel = [];
            this.errorArchivoModal = true;
          } else {
            // Filtrar los elementos nulos (en caso de que haya habido errores de validación)
            this.itemsDelExcel = this.itemsDelExcel.filter(
              item => item !== null
            );
            this.errorArchivo = false;
            this.errorArchivoModal = false;
          }
        })
        .catch((e: any) => {
          this.itemsDelExcel = [];
          this.errorMessage = `Ocurrió un error al leer el archivo: ${e.message}<br>`;
          this.errorArchivo = true;
          this.errorArchivoModal = true;
        });
    }
  }

  cargar() {
    this.loadingService.showLoading();
    const body = {
      user_id: JSON.parse(localStorage.getItem('user')).id,
      user: localStorage.getItem('clienteDefecto'),
      datos: this.itemsDelExcel,
    };
    let self = this;
    return fetchMS({ endpoint: 'get_bajas_report', body: body })
      .then(resp => {
        if (resp.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success(resp.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.itemsDelExcel = [];
          this.archivoB64 = '';
          this.fileName = '';
          this.errorArchivoModal = false;
          this.errorMessage = '';
          this.errorArchivo = true;
          this.$emit('cerrar');
        } else {
          self.errorMessage = resp.data.MENSAJE_RESPUESTA;
          self.errorArchivoModal = true;
          self.loadingService.hideLoading();
        }
        let input = document.getElementById(
          'archivoExcel'
        ) as HTMLInputElement | null;
        if (input) {
          input.value = ''; // Restablecer el valor del input
        }
        self.loadingService.hideLoading();
      })
      .catch(error => {
        if (error.message == 'Network Error') {
          self.$snotify.error('Ha ocurrido un error al ingresar el equipo', {
            timeout: 3000,
          });
        } else if (error.response.status != 404) {
          self.$snotify.error('Ha ocurrido un error al ingresar el equipo', {
            timeout: 3000,
          });
        }
        self.loadingService.hideLoading();
      })
      .finally(() => {
        self.loadingService.hideLoading();
      });
  }

  excelSerialToDate(serial: any): Date {
    if (serial == null) {
      return null;
    }
    // Excel serial date offset
    if (typeof serial == 'object') {
      //window.serial = serial;
      const offset = serial.getTimezoneOffset() * 60000;
      const correctDate = new Date(serial.getTime() + offset);
      return correctDate;
    }

    const utc_days = Math.floor(serial - 25569);
    const utc_value = utc_days * 86400;
    const date_info = new Date(utc_value * 1000);

    // Compensate for the timezone offset
    const offset = date_info.getTimezoneOffset() * 60000;
    const correctDate = new Date(date_info.getTime() + offset);

    return correctDate;
  }

  formatDate(date: string | number | Date) {
    const d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    return [year, month.padStart(2, '0'), day.padStart(2, '0')].join('-');
  }
}
